import './FilterOptionItemLabel.scss';

import type { ReactNodeRenderer } from '@components/CustomizableNode';
import CustomizableNode from '@components/CustomizableNode';
import { InnerHTMLRenderer } from '@components/InnerHTMLRenderer';
import useGeneralSettings from '@hooks/useGeneralSettings';
import type { Dict } from '@types';
import { capitalize, createClsNameMap, stripHtml } from '@utils';

export const clsNameMap = createClsNameMap({})('filter-option-item-label');

export type FilterOptionItemLabelProps = {
  label: React.ReactNode;
  settings?: {
    displayAllValuesInUppercaseForm?: boolean;
  };
  onRender?: ReactNodeRenderer;
};

export const formatLabel = (
  label: string,
  displayAllValuesInUppercaseForm = false,
  /**
   * NOTE: update type later
   */
  generalAppConfig: Dict
) => {
  let result = label;

  if (displayAllValuesInUppercaseForm) {
    result = result.toUpperCase();
    return result;
  }

  if (generalAppConfig?.forceCapitalizeFilterOptionValues) {
    return capitalize(result, { isLower: true });
  }

  if (generalAppConfig?.capitalizeFirstLetterFilterOptionValues) {
    return capitalize(result, { isLower: true, onlyFirstLetter: true });
  }

  if (generalAppConfig?.capitalizeFilterOptionValues) {
    return capitalize(result);
  }

  // stripHtml remove xss for all label of filter tree
  return stripHtml(result);
};

const FilterOptionItemLabel = ({ label, settings, onRender }: FilterOptionItemLabelProps) => {
  const { generalSettings } = useGeneralSettings();
  return (
    <CustomizableNode renderer={onRender}>
      <>
        {typeof label === 'string' ? (
          <InnerHTMLRenderer
            as='span'
            html={formatLabel(label, settings?.displayAllValuesInUppercaseForm, generalSettings)}
            className={clsNameMap.root()}
          />
        ) : (
          label
        )}
      </>
    </CustomizableNode>
  );
};

export default FilterOptionItemLabel;
